// extracted by mini-css-extract-plugin
module.exports = {"video":"home_video__3w2Qm","ant-layout-content":"home_ant-layout-content__1xndD","site-layout-background":"home_site-layout-background__2QKBK"};